
    // src/DownloadsTable.js
    import React from 'react';
    import './Download.css'
    
import MegaNavbar from '../Components/MegaNavbar';
import Footer from "../Components/Footer";


const downloads = [
  { name: 'Turnitin User Creation Guide', link: "../Oric Dowonload/Turnitin User Creation Guide.pdf"},
  { name: 'Turnitin Account Creation Form', link: "../Oric Dowonload/trurnitin_account.pdf" },
  { name: 'Application Form for Anti-Plagiarism Test Certificate for Thesis/Research Proposal/Project', link: "../Oric Dowonload/Application_fromm.pdf" },
  { name: 'Guidelines on Turnitin', link: "../Oric Dowonload/Guidelines.pdf"},
  { name: 'Plagiarism Policy', link: "../Oric Dowonload/Plagiarism.pdf" },
  { name: 'The Little Book of Plagiarism', link: "../Oric Dowonload/ttile_book_plagiarsm.pdf" },
  { name: 'Application Form for Travel Grant to Present Paper', link: "../Oric Dowonload/Application_from_travel_grant.pdf"},
  { name: 'HEC Application Form Grant for Organizing Conferences/Seminars/Symposium', link: "../Oric Dowonload/HEC_Application_form.pdf" },
  { name: 'HEC Application Form for Organizing Workshop', link: "../Oric Dowonload/HEC_from_workshop.pdf" },
  { name: 'ORIC Strategic Plan', link: "../Oric Dowonload/ORIC Strategic Plan 2023-28.pdf" },
  { name: 'RESEARCH POLICY', link: "../Oric Dowonload/RESEARCH POLICY-ac final.pdf" },
  { name: 'Revised IP Policy', link: "../Oric Dowonload/Revised IP Policy.pdf" },
  { name: 'Minutes of 1st ORIC-SC Meeting', link: "../Oric Dowonload/Minutes of 1st ORIC-SC Meeting.pdf" },
  { name: 'Minutes of 2nd ORIC-SC Meeting', link: "../Oric Dowonload/Minutes of 2nd ORIC-SC Meeting.pdf" },
  { name: 'Minutes of the 3rd ORIC-SC meeting', link: "../Oric Dowonload/Minutes of the 3rd ORIC-SC meeting.pdf" },
];

const Downloads = () => {
  return (
    <>
    <MegaNavbar/>
    <div className='container'>
    <div className="downloads-container">
      <h2>ORIC Downloads</h2>
      <table className="downloads-table">
        <tbody>
          {downloads.map((download, index) => (
            <tr key={index}>
              <td>
                <a href={download.link} download>{download.name}</a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
  <Footer/>
      </>
  );
};
export default Downloads
